import { render, staticRenderFns } from "./CustomerChat.vue?vue&type=template&id=2c9dc9c0&scoped=true&"
import script from "./CustomerChat.vue?vue&type=script&lang=ts&"
export * from "./CustomerChat.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerChat.vue?vue&type=style&index=0&id=2c9dc9c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9dc9c0",
  null
  
)

export default component.exports